import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Children from "src/components/panel/children/Children";

const ChildrenView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("children_tab")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb
          title={t("children_title")}
          subtitle={t("children_subtitle")}
        />
        <Children />
      </Sidebar>
    </>
  );
};

export default ChildrenView;
